import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools } from "@fortawesome/free-solid-svg-icons";

const MaintenanceIndex = () => {
    return (
        <div>
            <header id="header">
                <div className="container">
                    <br />
                    <br />
                    <br />
                </div>
            </header>
            <div className="container txt-center">
                <h1>
                    <FontAwesomeIcon icon={faTools} style={{ fontSize: "100px" }} />
                </h1>
                <h3>Site is down for maintenance.</h3>
            </div>
        </div>
    );
};

export default MaintenanceIndex;
